import { Controller } from "@hotwired/stimulus";

// Hides some element when something is clicked
export default class extends Controller {
  dismiss() {
    this.element.classList.add('is-hidden');
  }
}
